<template>
  <div>
      <MobileHomeTransactionList/>
  </div>
</template>

<script>

import MobileHomeTransactionList from '../../../components/tax/TaxInquiry/MobileHome/MobileHomeTransactionList.vue';

export default {
  name: 'MobileHome',
  components: {
    MobileHomeTransactionList,
  },
};
</script>
